export default {
  general: {
    settings: "设置",
    show_time: "显示时间",
    show_seconds: "显示秒钟",
    show_search: "显示搜索栏",
    show_wallpaper: "显示切换背景按钮",
    show_bookmark: "显示书签按钮",
    show_weather: "显示天气",
    show_top_sites: "显示常用网站",
    auto_change_background: "自动切换背景",
    auto_change_every: "切换间隔",
    days: "天",
    hours: "小时",
    minutes: "分钟",
    interval_required: "天、小时和分钟不能同时为 0",
    sync_enabled: "启用待办云同步",
    show_ai_chat: "显示AI聊天按钮",
  },
  profile: {
    title: "个人资料",
    logout: "退出登录",
    sign_in: "登录",
    sign_in_desc: "请登录以解锁完整体验",
    avatar_updated: "头像更新成功",
    nickname_updated: "昵称更新成功",
    avatar_size: "头像文件大小不能超过500KB",
    login_required: "你必须登录才能更新头像",
    login_success: "登录成功",
    user_avatar: "用户头像",
    edit_avatar: "编辑头像",
    edit_nickname: "编辑昵称",
    save: "保存",
    cancel: "取消"
  },
  subscription: {
    title: "订阅",
    check: "查看我的订阅",
    upgrade: "升级订阅",
    subscribe: "订阅Tabby",
    expired_on: "已于 {0} 过期",
    expires_on: "将于 {0} 过期",
    plans: {
      premium: "你已解锁Tabby的全部潜力，享受无限换壁纸、自定义背景和独家壁纸合集等更多功能。",
      pro: "升级你的订阅以解锁无限换壁纸、自定义背景和独家壁纸合集。",
      free: "订阅以解锁无限换壁纸、自定义背景和独家壁纸合集。"
    }
  },
  wallpaper: {
    title: "背景",
    upload: "上传自定义背景",
    upgrade_required: "升级到Pro/Premium计划以解锁自定义背景功能",
    images: "图片",
    hues: "渐变",
    anims: "动效",
    diy: "自定义",
    get_new: "获取新图",
    upload_background: "上传背景",
    add: "添加",
    remote_url: "远程图片URL",
    size_tip: "较小的背景文件可加快加载速度。大多数浏览器的文件大小限制为1.5MB。远程URL没有限制。",
    please_login: "请先登录",
    click_to_upload: "点击上传",
    video_gif_image: "视频、GIF或图片",
    background: "背景",
    or_enter_remote_background_url: "或输入远程背景URL",
    remote_url_placeholder: "https://example.com/image.jpg",
    custom_background_removed: "自定义背景已移除",
    failed_to_load_background: "加载背景失败",
    using_default: "使用默认背景",
    insufficient_storage: "存储空间不足",
    upload_failed: "上传失败",
    success: "成功",
    remote_background_added: "远程背景已添加",
    detecting_media_type: "正在检测媒体类型...",
    invalid_media_type: "无法识别的媒体类型",
    video_load_failed: "视频无法加载，请检查URL是否正确"
  },
  rewards: {
    title: "奖励",
    invite_friends: "邀请好友",
    get_access: "邀请好友解锁 Pro 折扣",
    total_invites: "邀请总数",
    your_discount: "我的折扣",
    no_pro_yet: "暂无",
    copy_link: "复制邀请链接",
    copied: "邀请链接已复制！",
    copy_failed: "复制链接失败",
    invite_description: "好友用你的链接注册成功",
    receive_credits: "你可享:1 个→95 折、2 个→92 折、3 个→85 折、4 个以上→8 折 · 好友享 95 折"
  },
  paywall: {
    title: "Tabby Pro",
    pro_active: "Pro 已激活",
    expires: "到期",
    free_plan: "免费版",
    tagline: "解锁完整聊天额度、云同步待办与全部壁纸功能。",
    monthly: "月付",
    yearly: "年付",
    month_period: "/月",
    year_period: "/年",
    billed_monthly: "按月订阅 · 随时取消",
    billed_yearly: "按年计费",
    checkout_usd: "结账",
    save_yearly: "比月付省 17%",
    best_value: "最划算",
    referral_price: "邀请折扣价",
    save: "省",
    subscribe_now: "立即订阅",
    current_plan: "当前套餐",
    processing: "处理中",
    waiting_title: "等待支付",
    waiting_desc: "请在新打开的窗口中完成支付。",
    payment_completed: "支付已完成",
    having_issues: "遇到问题",
    invite_save: "邀请好友,Pro 享折扣",
    sign_in_first: "请先登录",
    checkout_failed: "创建支付会话失败",
    payment_failed: "支付失败",
    payment_wrong: "出错了,请重试。",
    success_msg: "恭喜,支付成功",
    not_paid_msg: "支付尚未完成,请在新窗口完成支付或重试。",
    verify_failed: "验证支付状态失败,请重试或联系客服。",
    contact_email: "请联系邮箱:hi@tabbyio.com"
  },
  about: {
    title: "关于",
    version: "版本：1.3.11",
    contact: "联系我们：",
    privacy_policy: "隐私政策",
    terms_of_service: "服务条款"
  },
  tabs: {
    general: "偏好",
    profile: "个人资料",
    wallpaper: "背景",
    rewards: "奖励",
    about: "关于"
  },
  language: {
    title: "语言",
    en: "English",
    zh: "中文",
    de: "Deutsch",
    fr: "Français",
    pt: "Português",
    ru: "Русский",
    bn: "বাংলা",
    ja: "日本語",
    es: "Español"
  },
  buttons: {
    bookmark: "书签",
    next_background: "切换背景",
    ai_chat: "AI聊天",
    search_placeholder: "搜索或按 Ctrl + Enter 使用 AI 聊天...",
    attach: "添加附件",
    close: "关闭"
  },
  top_sites: {
    title: "常用网站",
    error: "无法加载常用网站",
    empty: "未找到常用网站",
    remove: "移除该网站",
    pin: "固定",
    unpin: "取消固定",
    delete: "删除"
  },
  greetings: {
    morning: "早上好",
    afternoon: "中午好",
    evening: "晚上好", 
    morning_message: "新的一天开始了，有什么可以帮您的吗？",
    afternoon_message: "午后时光，有什么问题想要咨询吗？",
    evening_message: "夜晚时分，我来陪您聊天吧！"
  },
  intro: {
    your_portal: "你的 专属空间",
    for: "用于",
    productivity: "提升效率。",
    inspiration: "获取灵感。",
    photography: "欣赏美景。",
    description: "让每个新标签页成为通往",
    description_continued: "优雅、高效和更多可能的入口。",
    add_to_chrome: "添加到Chrome",
    add_to_edge: "添加到Edge",
    add_to_firefox: "添加到Firefox",
    add_to_browser: "添加到浏览器",
    free: "免费",
    try_now: "立即体验",
    screenshot: "截图"
  }
}

